module.exports = __webpack_public_path__ + "bf3050f4013f0a7fd9139729cc367d42.pdf";